"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg16MoneyDefault = function Svg16MoneyDefault(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    d: "M12 16.27c.738 0 1.296-.205 1.667-.517.37-.312.563-.737.563-1.203 0-.308-.088-.547-.24-.742-.152-.198-.376-.36-.66-.5-.433-.214-.974-.366-1.558-.53-.19-.054-.384-.108-.58-.167-.788-.234-1.601-.528-2.217-1.055-.624-.534-1.035-1.299-1.035-2.446 0-1.47.808-2.3 1.605-2.755A4.59 4.59 0 0 1 11 5.836V5a1 1 0 0 1 2 0v.838a4.873 4.873 0 0 1 2.133.966c.394.31.367.888.013 1.242-.413.413-1.103.348-1.614.065A3.18 3.18 0 0 0 12 7.73c-1.222 0-1.89.725-1.89 1.38 0 .308.088.547.239.742.153.198.377.36.66.5.434.214.974.366 1.558.53.19.054.384.108.58.167.788.234 1.602.528 2.217 1.055.625.534 1.036 1.299 1.036 2.446 0 1.682-.892 2.598-1.778 3.085A4.792 4.792 0 0 1 13 18.17V19a1 1 0 1 1-2 0v-.833c-1.065-.15-2.081-.596-2.874-1.311-.36-.324-.32-.875.022-1.217.423-.423 1.133-.346 1.63-.012.643.434 1.44.643 2.222.643z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg16MoneyDefault.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg16MoneyDefault;
exports.default = _default;